import axios from "axios";
import { StandardAxiosConfig } from "../common";

export class MissionsAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${import.meta.env.VITE_ROGO_API_URL}/mission`;
	}

	/** Copy the planned lat/lon to the pulled lat/lon for the specified core */
	public async fudgeCore(jobId: string, coreId: string): Promise<void> {
		await this.fudgeCores(jobId, [coreId]);
	}

	/** Copy the planned lat/lon to the pulled lat/lon for the specified cores */
	public async fudgeCores(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/fudge`;
		await axios.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}

	/** Delete the specified core from the mission */
	public async deleteCore(jobId: string, coreId: string): Promise<void> {
		await this.deleteCores(jobId, [coreId]);
	}

	/** Delete the specified cores from the mission */
	public async deleteCores(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/delete`;
		await axios.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}
}
